import Clients from '../pages/Clients'
import PromoCodes from '../pages/PromoCodes'
import Configurations from '../pages/Configurations'
import Drivers from '../pages/Drivers'
import Products from '../pages/Products'
import Support from '../pages/Support'
import VentesStocks from '../pages/VentesStocks'
import PushNotification from '../pages/PushNotification'
import Categories from '../pages/Categories'
import InvoiceView from '../pages/Invoice'
import {
  Activation,
  CampaignPromoView,
  ContactSupport,
  DeepLink,
  DeliverySettings,
  DeliveryZone,
  GeneralConfig,
  HoursConfig,
  HubriseConfig,
  LoyaltyProgram,
  ManagementFee,
  marketingCampaigns,
  MobileDesign,
  OrderSettings,
  PaymentAndOrderTypesConfig,
  PrinterConfig,
  SpecialHoursConfig,
  WebDesign
} from '../components'
import Design from '../pages/Design'
import {
  ACTIVATION_ROUTE,
  CAMPAIGN_PROMO_ROUTE,
  CAMPAIGNS_ROUTE,
  CODE_PROMO_ROUTE,
  CONTACT_SUPPORT_ROUTE,
  DEEPLINK_ROUTE,
  DELIVERY_HOUR_ROUTE,
  DELIVERY_SETTINGS_ROUTE,
  DELIVERY_ZONE_ROUTE,
  FEDILITY_PROGRAM_ROUTE,
  GENERAL_CONFIG_ROUTE,
  GENERAL_DESIGN_ROUTE,
  HUBRISE_ROUTE,
  MANAGEMENT_FEE_ROUTE,
  MOBILE_DESIGN_ROUTE,
  OPENED_HOUR_ROUTE,
  ORDER_SETTINGS_ROUTE,
  PAYMENTS_ROUTE,
  PRINTER_ROUTE,
  PUSH_NOTIF_ROUTE,
  SALES_TYPE_ROUTE,
  SPECIFIC_HOUR_ROUTE,
  WEB_DESIGN_ROUTE
} from './routes'
import Marketing from '../pages/Marketing'
import Finances from '../pages/Finances'
import Assitance from '../pages/Assistance'
export default [
  { path: GENERAL_CONFIG_ROUTE, component: GeneralConfig, exact: true },
  { path: DELIVERY_ZONE_ROUTE, component: DeliveryZone, exact: true },
  { path: OPENED_HOUR_ROUTE, component: HoursConfig, exact: true },
  { path: DELIVERY_HOUR_ROUTE, component: HoursConfig, exact: true },
  { path: SPECIFIC_HOUR_ROUTE, component: SpecialHoursConfig, exact: true },
  { path: PAYMENTS_ROUTE, component: PaymentAndOrderTypesConfig, exact: true },
  { path: SALES_TYPE_ROUTE, component: PaymentAndOrderTypesConfig, exact: true },
  { path: PRINTER_ROUTE, component: PrinterConfig, exact: true },
  { path: DELIVERY_SETTINGS_ROUTE, component: DeliverySettings, exact: true },
  { path: ORDER_SETTINGS_ROUTE, component: OrderSettings, exact: true },
  { path: GENERAL_DESIGN_ROUTE, component: Design, exact: true },
  { path: HUBRISE_ROUTE, component: HubriseConfig, exact: true },
  { path: WEB_DESIGN_ROUTE, component: WebDesign, exact: true },
  { path: MOBILE_DESIGN_ROUTE, component: MobileDesign, exact: true },
  { path: FEDILITY_PROGRAM_ROUTE, component: LoyaltyProgram, exact: true },
  { path: ACTIVATION_ROUTE, component: Activation, exact: true },
  { path: MANAGEMENT_FEE_ROUTE, component: ManagementFee, exact: true },
  { path: DEEPLINK_ROUTE, component: DeepLink, exact: true },
  { path: CAMPAIGN_PROMO_ROUTE, component: CampaignPromoView, exact: true },
  { path: CAMPAIGNS_ROUTE, component: marketingCampaigns, exact: true },
  { path: CONTACT_SUPPORT_ROUTE, component: ContactSupport, exact: true },
  { title: 'Réglages', path: '/settings', component: Configurations },
  { title: 'Clients', path: '/clients', component: Clients },
  { title: 'Codes Promotionnels', path: CODE_PROMO_ROUTE, component: PromoCodes },
  { title: 'Livreurs', path: '/livreurs', component: Drivers },
  { title: 'Produits', path: '/products', component: Products },
  { title: "Listes d'options", path: '/options-products', component: Categories },
  { title: 'Support', path: '/support', component: Support },
  { title: 'Push Notifications', path: PUSH_NOTIF_ROUTE, component: PushNotification },
  { title: 'Ventes / Stocks', path: '/sales', component: VentesStocks },
  { title: 'Factures', path: '/invoice', component: InvoiceView },
  { title: 'Marketing', path: '/marketing', component: Marketing },
  { title: 'Finances', path: '/finances', component: Finances },
  { title: `Besoin d'aide`, path: '/help', component: Assitance },

];
